var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":'Saving data...',"closeButton":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('p',{staticClass:"pt-5 pl-3"},[_vm._v(" Please wait. Your data is being saved. ")]),_c('div',{staticClass:"d-flex justify-content-center"},[_c('Loading',{staticClass:"my-5"})],1)])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }